export interface Testimonial {
  quote: string;
  name: string;
  role: string;
  location?: string;
}

const TESTIMONIALS: Testimonial[] = [
  {
    quote:
      'Pressto offers a compelling vision for how structured writing supports deeper learning across subjects. The ability to align writing activities with any curriculum instantly is a game-changer for both teachers and students.',
    name: 'Jason Borges',
    role: 'Executive Director, NYC Reads',
  },
  {
    quote:
      'This tool scaffolds the writing process for students and gives them a super creative way to share what they have learned — in any subject area.',
    name: 'Monica Burns',
    role: 'ClassTechTips',
  },
  {
    quote:
      'The art of teaching writing can be a complex concept for many teachers. Pressto allows teachers to motivate students and provide them with the confidence needed to become writers. Students are able to see themselves as authors of their craft. They are able to align standard-based content to the writing process which results in stronger writers.',
    name: "Sandra D'Avilar",
    role: 'Executive Director, NYC Dept of Ed.',
  },
  {
    quote:
      'The writing prompt generator is very impressive. It makes it easy to create a quick assignment to wrap up a teaching session; it reminds students about how to connect ideas with the signal words for the writing style I select.',
    name: 'Kevin C.',
    role: 'Grade 10 ELA Teacher',
    location: 'Indiana',
  },
  {
    quote:
      'The real-time feedback is so important to keep students engaged. The ability for me to monitor the whole class and comment on any individual work in real-time is amazing.',
    name: 'Alison W.',
    role: 'Teacher',
    location: 'New York',
  },
  {
    quote:
      'Our students love it, the teacher loves it, and it\'s inspired our writers. You couldn\'t ask for anything more than that.',
    name: 'Ms. Gundersen',
    role: 'Teacher',
  },
  {
    quote:
      'I recommend this program as a strong motivating supplement to support students with their writing across subject areas.',
    name: 'Ms. Zutter',
    role: 'Teacher',
  },
  {
    quote:
      'Most important, students loved that they could have their own magazine, and everyone could share their stories. It makes writing much more fun and interesting.',
    name: 'Ms. Porfirio',
    role: 'Teacher',
  },
];

export default TESTIMONIALS;
